

import { defineAsyncComponent } from 'vue';

const SpacemenBlock = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/SpacemenBlock" */ './components/SpacemenBlock.vue');
});
const ThemeSelectorDesktop = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/ThemeSelectorDesktop" */ './components/ThemeSelectorDesktop.vue');
});
const ThemeSelectorMobile = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/ThemeSelectorMobile" */ './components/ThemeSelectorMobile.vue');
});

const Testimonials = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/Testimonials" */ './components/Testimonials.vue');
});
const Projects = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/Projects" */ './components/Projects.vue');
});
const ProjectCarousel = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/ProjectCarousel" */ './components/ProjectCarousel.vue');
});
const ContactForm = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/ContactForm" */ './components/ContactForm.vue');
});
const CookieBanner = defineAsyncComponent(() => {
	return import( /* webpackChunkName: "js/components/CookieBanner" */ './components/CookieBanner.vue');
});



export default {
	components: {
		SpacemenBlock,
    ThemeSelectorMobile,
		ThemeSelectorDesktop,
    Testimonials,
    Projects,
    ProjectCarousel,
    ContactForm,
    CookieBanner
	},

	data() {
		return {
			mobileMenuIsOpen: false
		}
	}
}

